import { Component } from '@angular/core';

@Component({
  selector: 'app-ebi-header',
  templateUrl: './ebi-header.component.html',
  styleUrl: './ebi-header.component.scss',
  standalone: false
})
export class EbiHeaderComponent {

}
